import { rrulestr } from "rrule";

import { RRuleFinnish } from "../../helpers";
import { InputBase } from "./_InputBase";



/**
 * Controller for Recurrence Rule (RRule) edit input
 */

export class InputRruleController extends InputBase<string> {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = [];

  /**
   * Creates a new InputController
   * @ignore
   */
  constructor() {
    super();
  }

  /**
   * Gets the recurrence rule as human readable text.
   * @param rrule The iCalendar Recurrence rule that should be interpreted.
   */
   public getRRuleText(rrule: string) {
    const rule = rrulestr(rrule, {
      // dtstart: Dates.asDate,
    });
    return rule.toText((id) => {
      return RRuleFinnish.texts[id.toString()] || id.toString();
    }, RRuleFinnish, (year: number, month: string, day: number) => {
      return `${day}. ${month}ta ${year}`;
    });
  }
}
